import { gql } from '@apollo/client';

export const CREATE_AUTH0_IDENTITY_MUTATION = gql`
  mutation createAuth0Identity($input: CreateAuth0IdentityInput) {
    createAuth0Identity(input: $input) {
      id
    }
  }
`;
